<template>
  <d-modal
    :title="$t('profile.change-password.title')"
    :modal="modal"
    :isSubmitting="isSubmitting"
    @submitModal="handleSubmitModal"
    @closeModal="handleCloseModal"
  >
    <template slot="body">
      <v-form ref="form" lazy-validation @submit.prevent="handleSubmitModal">
        <v-row>
          <v-col cols="12" class="mb-3">
            <v-text-field
              :label="$t('profile.change-password.form.old-password')"
              persistent-hint
              v-model.trim="form.oldPassword"
              hide-details="auto"
              filled
              :type="isOldPasswordVisible ? 'text' : 'password'"
              :append-icon="getPasswordInputIcon(isOldPasswordVisible)"
              @click:append="isOldPasswordVisible = !isOldPasswordVisible"
              :rules="rules.oldPassword"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="mb-3">
            <v-text-field
              :label="$t('profile.change-password.form.password.label')"
              :hint="$t('profile.change-password.form.password.hint')"
              persistent-hint
              v-model.trim="form.password"
              hide-details="auto"
              filled
              :type="isPasswordVisible ? 'text' : 'password'"
              :append-icon="getPasswordInputIcon(isPasswordVisible)"
              @click:append="isPasswordVisible = !isPasswordVisible"
              :rules="rules.password"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              :label="$t('profile.change-password.form.confirm-password')"
              v-model.trim="form.confirmPassword"
              hide-details="auto"
              filled
              :type="isConfirmPasswordVisible ? 'text' : 'password'"
              :append-icon="getPasswordInputIcon(isConfirmPasswordVisible)"
              @click:append="
                isConfirmPasswordVisible = !isConfirmPasswordVisible
              "
              :rules="rules.confirmPassword"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </d-modal>
</template>

<script>
const initialForm = {
  oldPassword: null,
  password: null,
  confirmPassword: null,
};

export default {
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isSubmitting: false,
      isOldPasswordVisible: false,
      isPasswordVisible: false,
      isConfirmPasswordVisible: false,
      form: { ...initialForm },
      rules: {
        oldPassword: [(v) => !!v || this.$t("defaults.rule.required")],
        password: [
          (v) => !!v || this.$t("defaults.rule.required"),
          (v) =>
            this.$constants.PASSWORD_REGEX.test(v) ||
            this.$t("profile.change-password.rule.password.invalid"),
        ],
        confirmPassword: [
          (v) => !!v || this.$t("defaults.rule.required"),
          (v) => {
            if (!this.form.password) return true;

            if (v === this.form.password) return true;

            return this.$t(
              "profile.change-password.rule.confirm-password.not-match"
            );
          },
        ],
      },
    };
  },
  methods: {
    getPasswordInputIcon(isVisible) {
      return isVisible ? "mdi-eye-off" : "mdi-eye";
    },
    handleCloseModal() {
      this.$refs.form.reset();
      this.form = { ...initialForm };
      this.$emit("closeModal");
    },
    handleSubmitModal() {
      if (this.$refs.form.validate()) {
        this.isSubmitting = true;
        window.API.updateUserPassword(this.form)
          .then(() => {
            this.$eventBus.$emit("notification", {
              type: "success",
              message: this.$t("profile.change-password.alert.changed"),
            });
            this.handleCloseModal();
          })
          .catch((error) => {
            this.$eventBus.$emit("notification", {
              type: "error",
              message: this.$t(
                error.response.data.code === "OLD_PASSWORD_INCORRECT"
                  ? "profile.change-password.alert.old-password-incorrect"
                  : "profile.change-password.alert.could-not-change"
              ),
            });
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      }
    },
  },
};
</script>
